import { useParams } from "react-router-dom";
import CommonCertificateNotesForm from "../../../../components/common/CertificateNotesGrid/CertificateNotesGrid";
import { useState } from "react";
import CertNoteAddOrUpdateModal from "../../../../components/common/CertificateNotesGrid/CertNoteAddOrUpdateModal";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import {
  useDeleteCertificateNoteByIdMutation,
  useGetCertificateNotesByReferenceIdQuery
} from "../../../../components/common/CertificateNotesGrid/CertificateNotesApi";



const ManagementCompanyCertificateNotesForm = () => {
  const { companyId } = useParams();
  const [noteObject, setNoteObject] = useState(null);
  const [showNoteUpdateModel, setShowNoteUpdateModel] = useState(false);
  const [certificateNoteId, setCertificateNoteId] = useState(null);
  const [showManagementCertificateModal, setShowManagementCertificateModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteNotesApi, { isLoading }] = useDeleteCertificateNoteByIdMutation();
  const {
    data: certificateNotes,
  } = useGetCertificateNotesByReferenceIdQuery(companyId || "");

  const handleDeleteCertificateNotes = async (e: any) => {
    e.preventDefault();
    if (certificateNoteId !== null && certificateNoteId !== '') {
      try {
        await deleteNotesApi(certificateNoteId);
        setShowDeleteConfirm(false);
      } catch (error) {
        console.error('Error deleting certificate note:', error);
      }
    }
  };



  return (

    <div className={"mt-3"}>
      <CommonCertificateNotesForm
        title={"Management Company Certificate Notes"}
        data={certificateNotes}
        relationalId={companyId}
        count={certificateNotes?.length || 0}
        setShowAddNoteModal={setShowManagementCertificateModal}
        setNoteObject={setNoteObject}
        setShowNoteUpdateModel={setShowNoteUpdateModel}
        setNoteId={setCertificateNoteId}
        setShowDeleteConfirm={setShowDeleteConfirm}
      />

      {showManagementCertificateModal &&
        <CertNoteAddOrUpdateModal title={"Add Management Company Certificate Note"}
          show={showManagementCertificateModal}
          setShow={setShowManagementCertificateModal}
          relationalId={companyId}
          type={"MgmtCo"}
          length={certificateNotes && certificateNotes.length + 1}
          btnName="Add" />}


      {showNoteUpdateModel &&
        <CertNoteAddOrUpdateModal title={"Update Management Company Certificate Note"}
          show={showNoteUpdateModel}
          setShow={setShowNoteUpdateModel}
          noteObj={noteObject}
          relationalId={companyId}
          btnName={"Update"} type={"MgmtCo"}
        />
      }

      {showDeleteConfirm && <ConfirmationModal title={"Delete Management Company Certificate Note"}
        bodyMessage={"Are you sure you want to delete this certificate note?"}
        onSubmit={handleDeleteCertificateNotes}
        show={showDeleteConfirm}
        setShow={setShowDeleteConfirm}
        isLoading={isLoading}
      />
      }
    </div>
  );
};

export default ManagementCompanyCertificateNotesForm;